import type { LangResponse } from "../@api/langJson";
import { langJsonGet } from "../@api/langJson";
import { getPreferredLanguage } from "@kivra/sdk/copy-consumer";
import type { KnownLanguage } from "@kivra/sdk/types";

const languages: Record<KnownLanguage<"fi">, string> = {
  en: "/en-fi.json",
  fi: "/fi-fi.json",
  sv: "/sv-fi.json",
};
const options = {
  useBrowserLocale: true,
};

export function fetchLangJson(): Promise<{
  lang: LangResponse;
  initLang: KnownLanguage<"fi">;
}> {
  return langJsonGet().then((lang) => ({ lang, initLang: getLang() }));
}

type KnownLanguages = [KnownLanguage<"fi">, ...Array<KnownLanguage<"fi">>];

export function getLang(): KnownLanguage<"fi"> {
  const langs = Object.keys(languages) as KnownLanguages;
  return getPreferredLanguage(langs, "fi", options);
}
